var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-snackbar",
        {
          staticClass: "custom-snackbar",
          attrs: {
            color: _vm.popup.type,
            timeout: 3000,
            top: "top",
            bottom: false
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function(ref) {
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { dark: "", text: "" },
                        on: {
                          click: function($event) {
                            _vm.popup.visible = false
                          }
                        }
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v("Close")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.popup.visible,
            callback: function($$v) {
              _vm.$set(_vm.popup, "visible", $$v)
            },
            expression: "popup.visible"
          }
        },
        [_vm._v(" " + _vm._s(_vm.popup.text) + " ")]
      ),
      _c(
        "v-snackbar",
        {
          staticClass: "custom-snackbar",
          attrs: {
            color: _vm.bottomPopup.type,
            timeout: 3000,
            top: false,
            bottom: "bottom"
          },
          model: {
            value: _vm.bottomPopup.visible,
            callback: function($$v) {
              _vm.$set(_vm.bottomPopup, "visible", $$v)
            },
            expression: "bottomPopup.visible"
          }
        },
        [_vm._v(_vm._s(_vm.bottomPopup.text))]
      ),
      _vm.selectedLocation.nasid && _vm.selectedLocation.nasid > 0
        ? _c(
            "v-dialog",
            {
              attrs: {
                fullscreen: "",
                "hide-overlay": "",
                transition: "dialog-bottom-transition",
                app: ""
              },
              model: {
                value: _vm.showAdvancedSettings,
                callback: function($$v) {
                  _vm.showAdvancedSettings = $$v
                },
                expression: "showAdvancedSettings"
              }
            },
            [
              _c("AdvancedSettings", {
                attrs: {
                  showAdvancedSettings: _vm.showAdvancedSettings,
                  advancedSettings: _vm.advancedSettings
                },
                on: {
                  save: function($event) {
                    return _vm.SaveAdvancedSetting($event)
                  },
                  error: function($event) {
                    return _vm.showAdvancedSettingsError($event)
                  },
                  close: function($event) {
                    _vm.showAdvancedSettings = false
                    _vm.GetAdvancedSettings()
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.selectedLocation.nasid && _vm.selectedLocation.nasid > 0
        ? _c(
            "v-dialog",
            {
              staticStyle: { left: "unset", width: "640px" },
              attrs: {
                fullscreen: "",
                "hide-overlay": "",
                transition: "dialog-bottom-transition",
                app: ""
              },
              model: {
                value: _vm.planNPayOn,
                callback: function($$v) {
                  _vm.planNPayOn = $$v
                },
                expression: "planNPayOn"
              }
            },
            [
              _c("PlanAndPayment", {
                key: "planAndPayment_" + _vm.planNPayPage,
                attrs: {
                  page: _vm.planNPayPage,
                  plans: _vm.dataPlanSettings,
                  selectedLocation: this.selectedLocation,
                  editUpi: _vm.editUpi,
                  fromSettings: true
                },
                on: {
                  close: function($event) {
                    _vm.planNPayOn = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-tabs",
        {
          attrs: {
            color: "#f26547",
            "background-color": "transparent",
            grow: ""
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c(
            "v-tab",
            {
              staticClass: "fs-14 fw-400 text-capitalize",
              staticStyle: {
                "font-weight": "500",
                "font-size": "16px",
                "font-family": "inherit",
                "letter-spacing": "normal"
              },
              on: {
                click: function($event) {
                  return _vm.refreshUsage()
                }
              }
            },
            [_vm._v("Usage")]
          ),
          _c(
            "v-tab",
            {
              staticClass: "fs-14 fw-400 text-capitalize",
              staticStyle: {
                "font-weight": "500",
                "font-size": "16px",
                "font-family": "inherit",
                "letter-spacing": "normal"
              },
              on: {
                click: function($event) {
                  return _vm.refreshCustomers()
                }
              }
            },
            [_vm._v("Customers")]
          ),
          _vm.selectedLocation.nasid &&
          _vm.couponOnlyFlowNasids.indexOf(_vm.selectedLocation.nasid) < 0
            ? _c(
                "v-tab",
                {
                  staticClass: "fs-14 fw-400 text-capitalize",
                  staticStyle: {
                    "font-weight": "500",
                    "font-size": "16px",
                    "font-family": "inherit",
                    "letter-spacing": "normal"
                  },
                  on: {
                    click: function($event) {
                      return _vm.refreshSettings()
                    }
                  }
                },
                [_vm._v("Settings")]
              )
            : _vm._e()
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c(
            "v-tab-item",
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "justify-content": "center",
                            color: "#999"
                          }
                        },
                        [_vm._v("Guest WiFi Status:")]
                      ),
                      _c(
                        "v-col",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "justify-content": "center",
                            "margin-left": "33px"
                          }
                        },
                        [
                          !_vm.nonPremium() &&
                          _vm.selectedLocation.connectionStatus == 1
                            ? _c(
                                "span",
                                {
                                  staticClass: "compact-bold",
                                  staticStyle: {
                                    color: "#68d391",
                                    "margin-left": "-35px"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "18px",
                                      position: "relative",
                                      bottom: "-3px",
                                      "margin-left": "-15px"
                                    },
                                    attrs: {
                                      src: require("img/icons/tick.png")
                                    }
                                  }),
                                  _vm._v(" Working ")
                                ]
                              )
                            : _vm._e(),
                          _vm.nonPremium() ||
                          _vm.selectedLocation.connectionStatus == 0
                            ? _c(
                                "span",
                                {
                                  key: "'status'+reportData.connectionStatus",
                                  staticClass: "compact-bold",
                                  staticStyle: { color: "#ff4444" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit("troubleshoot", true)
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "18px",
                                      position: "relative",
                                      bottom: "-3px",
                                      "margin-left": "-25px"
                                    },
                                    attrs: {
                                      src: require("img/icons/tick.png")
                                    }
                                  }),
                                  _vm._v(" Not-Working ")
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-sheet",
                    {
                      staticStyle: { margin: "10px -15px 0px -15px" },
                      attrs: { elevation: "2" }
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "pr-2 fw-800 text-uppercase",
                                          staticStyle: {
                                            color: "#48bb78",
                                            "font-weight": "bold"
                                          }
                                        },
                                        [_vm._v("User")]
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            bottom: "",
                                            "max-width": "207",
                                            "max-height": "57"
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      {
                                                        staticClass:
                                                          "help-icon",
                                                        staticStyle: {
                                                          position: "relative",
                                                          bottom: "2px"
                                                        }
                                                      },
                                                      on
                                                    ),
                                                    [_vm._v("mdi-help")]
                                                  )
                                                ]
                                              }
                                            }
                                          ])
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Total number of users connected to your Wi-Fi"
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm.reportData.totalUsers <= 999
                                        ? _c(
                                            "v-card-title",
                                            {
                                              staticStyle: {
                                                color: "#484848",
                                                "font-size": "3.6rem",
                                                "padding-top": "0px",
                                                "justify-content": "center"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.totalUserChart = true
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.reportData.totalUsers
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "report-card-data-unit",
                                                  staticStyle: {
                                                    visibility: "hidden"
                                                  }
                                                },
                                                [_vm._v("MB")]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.reportData.totalUsers > 999
                                        ? _c(
                                            "v-card-title",
                                            {
                                              staticStyle: {
                                                color: "#484848",
                                                "font-size": "3.6rem",
                                                "padding-top": "0px",
                                                "justify-content": "center"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.totalUserChart = true
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    parseFloat(
                                                      _vm.reportData
                                                        .totalUsers / 1000
                                                    ).toFixed(1)
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "report-card-data-unit"
                                                },
                                                [_vm._v("K")]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "text-right" },
                            [
                              _c(
                                "v-menu",
                                {
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass:
                                                  "white text-capitalize",
                                                staticStyle: {
                                                  "margin-right": "10px",
                                                  "font-weight": "normal",
                                                  color: "#999",
                                                  "font-size": "14px",
                                                  "letter-spacing": "normal"
                                                },
                                                attrs: { depressed: "" }
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    "margin-right": "2px",
                                                    color: "#666"
                                                  },
                                                  attrs: { left: "", dark: "" }
                                                },
                                                [_vm._v("mdi-calendar-blank")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.reportData.userDuration
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "5px"
                                                  },
                                                  attrs: { right: "" }
                                                },
                                                [_vm._v("mdi-chevron-down")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _c(
                                    "v-list",
                                    [
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.GetTotalUserinXDays(1)
                                              _vm.reportData.userDuration =
                                                "Today"
                                            }
                                          }
                                        },
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v("Today")
                                          ])
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.GetTotalUserinXDays(7)
                                              _vm.reportData.userDuration =
                                                "7 days"
                                            }
                                          }
                                        },
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v("7 days")
                                          ])
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.GetTotalUserinXDays(30)
                                              _vm.reportData.userDuration =
                                                "Last Month"
                                            }
                                          }
                                        },
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v("Last Month")
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-sheet",
                    {
                      staticStyle: {
                        margin: "10px -15px 0px -15px",
                        height: "145px"
                      },
                      attrs: { elevation: "2" }
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "pr-2 fw-800 text-uppercase",
                                          staticStyle: {
                                            color: "#214294",
                                            "font-weight": "bold"
                                          }
                                        },
                                        [_vm._v("Data Used")]
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            bottom: "",
                                            "max-width": "207",
                                            "max-height": "57"
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      {
                                                        staticClass:
                                                          "help-icon",
                                                        staticStyle: {
                                                          "margin-top": "-3px"
                                                        }
                                                      },
                                                      on
                                                    ),
                                                    [_vm._v("mdi-help")]
                                                  )
                                                ]
                                              }
                                            }
                                          ])
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Total data consumed by all users"
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {},
                                    [
                                      _c(
                                        "v-card-title",
                                        {
                                          staticStyle: {
                                            color: "#484848",
                                            "font-size": "3.6rem",
                                            "padding-top": "0px",
                                            "justify-content": "center",
                                            "margin-left": "5px !important",
                                            "margin-top": "-15px !important"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.FormatData(
                                                  _vm.reportData.totalDataUsed
                                                )[0]
                                              ) +
                                              " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "1rem",
                                                "padding-top": "32px",
                                                color: "#999"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.FormatData(
                                                    _vm.reportData.totalDataUsed
                                                  )[1]
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "text-right" },
                            [
                              _c(
                                "v-menu",
                                {
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass:
                                                  "white text-capitalize",
                                                staticStyle: {
                                                  "margin-right": "10px",
                                                  "font-weight": "normal",
                                                  color: "#999",
                                                  "font-size": "14px",
                                                  "letter-spacing": "normal",
                                                  "text-align": "center"
                                                },
                                                attrs: { depressed: "" }
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    "margin-right": "2px",
                                                    color: "#666"
                                                  },
                                                  attrs: { left: "", dark: "" }
                                                },
                                                [_vm._v("mdi-calendar-blank")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.reportData.dataDuration
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "5px"
                                                  },
                                                  attrs: { right: "" }
                                                },
                                                [_vm._v("mdi-chevron-down")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _c(
                                    "v-list",
                                    [
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.GetTotalDataInXDays(1)
                                              _vm.reportData.dataDuration =
                                                "Today"
                                            }
                                          }
                                        },
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v("Today")
                                          ])
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.GetTotalDataInXDays(7)
                                              _vm.reportData.dataDuration =
                                                "7 days"
                                            }
                                          }
                                        },
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v("7 days")
                                          ])
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.GetTotalDataInXDays(30)
                                              _vm.reportData.dataDuration =
                                                "Last Month"
                                            }
                                          }
                                        },
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v("Last Month")
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.nonPremium()
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            border: "solid 1px red",
                            "margin-left": "-5px",
                            width: "100%",
                            "background-color": "rgba(255,255,255,0.9)",
                            display: "block",
                            height: "85px",
                            position: "absolute",
                            top: "10px",
                            "text-align": "center"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "block",
                                position: "relative",
                                top: "5px"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "35", height: "35px" },
                                attrs: { src: require("img/locked.svg") }
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "block",
                                    "font-weight": "bold",
                                    "font-size": "12px",
                                    "margin-top": "-3px"
                                  }
                                },
                                [
                                  _vm._v("Premium Feature "),
                                  _c("br"),
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.GoToPaymentPage()
                                        }
                                      }
                                    },
                                    [_vm._v("PAY TO UPGRADE")]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-tab-item",
            [
              _c(
                "v-container",
                {
                  staticClass: "customer-container",
                  staticStyle: { padding: "0 !important" }
                },
                [
                  _c(
                    "section",
                    { staticClass: "pb-3 px-1" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-right py-0 px-0" },
                        [
                          _c(
                            "v-menu",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            staticClass:
                                              "white text-capitalize",
                                            staticStyle: {
                                              "margin-right": "10px",
                                              "font-weight": "normal",
                                              color: "#999",
                                              "font-size": "0.75rem",
                                              "letter-spacing": "normal"
                                            },
                                            attrs: { depressed: "" }
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticStyle: {
                                                "margin-right": "2px",
                                                color: "#666",
                                                "font-size": "1rem"
                                              },
                                              attrs: { left: "", dark: "" }
                                            },
                                            [_vm._v("mdi-calendar-blank")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.cumulatedData.text) +
                                              " "
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              staticStyle: {
                                                "margin-left": "5px"
                                              },
                                              attrs: { right: "" }
                                            },
                                            [_vm._v("mdi-chevron-down")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _c(
                                "v-list",
                                [
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticStyle: {
                                            "font-size": "0.75rem"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.updateCumuilativeData({
                                                text: "Today"
                                              })
                                            }
                                          }
                                        },
                                        [_vm._v("Today")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticStyle: {
                                            "font-size": "0.75rem"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.updateCumuilativeData({
                                                text: "7 days"
                                              })
                                            }
                                          }
                                        },
                                        [_vm._v("7 days")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticStyle: {
                                            "font-size": "0.75rem"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.updateCumuilativeData({
                                                text: "Last 30 days"
                                              })
                                            }
                                          }
                                        },
                                        [_vm._v("Last Month")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "bg-green boxshadow",
                              attrs: { "max-width": "155" }
                            },
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "text-capitalize text-center" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "mb-0",
                                      staticStyle: {
                                        "font-size": "0.875rem",
                                        "font-weight": "700",
                                        width: "6rem"
                                      }
                                    },
                                    [_vm._v(" Total Earnings ")]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "mb-0",
                                      staticStyle: {
                                        "font-size": "x-large",
                                        "font-weight": "700",
                                        "padding-top": "0.125rem"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " ₹" +
                                          _vm._s(this.cumulatedData.earning) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-card",
                            {
                              staticClass: "ml-3 boxshadow",
                              attrs: { "max-width": "155" }
                            },
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "text-capitalize text-center" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "mb-0",
                                      staticStyle: {
                                        "font-size": "0.875rem",
                                        "font-weight": "700",
                                        width: "6rem"
                                      }
                                    },
                                    [_vm._v(" Total Users ")]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "mb-0",
                                      staticStyle: {
                                        "font-size": "x-large",
                                        "font-weight": "700",
                                        "padding-top": "0.125rem"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(this.cumulatedData.requests) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "margin-bottom": "1rem"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: {
                            "text-transform": "none",
                            background: "#f06b69",
                            color: "white"
                          },
                          on: {
                            click: function($event) {
                              return _vm.planNPayMethod({ page: "send-coupon" })
                            }
                          }
                        },
                        [_vm._v(" Send Coupon ")]
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "header" }, [
                    _c("ul", {}, [
                      _c("li", { staticClass: "customer-record" }, [
                        _c("span", [_vm._v("Mobile")]),
                        _c("span", [_vm._v("Date")]),
                        _c("span", [_vm._v("Plan")]),
                        _c("span", [_vm._v("Payment")]),
                        _c("span", { staticStyle: { color: "transparent" } }, [
                          _vm._v("Payment")
                        ])
                      ])
                    ])
                  ]),
                  _vm.customerPopup.user
                    ? _c("CustomerPopup", {
                        ref: "'customerPopup_' + customerPopup.type",
                        attrs: {
                          popupData: _vm.customerPopup,
                          selectedLocation: _vm.selectedLocation
                        },
                        on: {
                          "refresh-registered-users": function($event) {
                            return _vm.GetUsers()
                          },
                          closed: function($event) {
                            _vm.customerPopup.user = null
                          }
                        }
                      })
                    : _vm._e(),
                  _c(
                    "v-expansion-panels",
                    {
                      attrs: { accordion: "", multiple: "" },
                      model: {
                        value: _vm.panel,
                        callback: function($$v) {
                          _vm.panel = $$v
                        },
                        expression: "panel"
                      }
                    },
                    [
                      _vm.pendingRegisterUser &&
                      _vm.pendingRegisterUser.length > 0
                        ? _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "700"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Pending (" +
                                      _vm._s(_vm.pendingRegisterUser.length) +
                                      ")"
                                  )
                                ]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { staticStyle: { padding: "0 0.5rem" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pending-div",
                                      staticStyle: { margin: "0 -1rem" }
                                    },
                                    [
                                      _c(
                                        "ul",
                                        {
                                          staticStyle: { "padding-left": "0" }
                                        },
                                        [
                                          _vm._l(
                                            _vm.pendingRegisterUser,
                                            function(user, index) {
                                              return _c(
                                                "li",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "customer-record",
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      _vm.customerPopup = {
                                                        user: user,
                                                        type: "pending"
                                                      }
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(user.mobile)
                                                      )
                                                    ])
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .dateFormat(
                                                            user.planStartTime
                                                          )
                                                          .substring(0, 6)
                                                      )
                                                    )
                                                  ]),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.dataFormat(
                                                          1024 *
                                                            user.dataLimit *
                                                            1024
                                                        )
                                                      ) +
                                                        "/" +
                                                        _vm._s(
                                                          _vm.timeFormat(
                                                            user.timePlan
                                                          )
                                                        )
                                                    )
                                                  ]),
                                                  user.charges
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            "₹ " + user.charges
                                                          )
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  !user.charges
                                                    ? _c("span", [_vm._v("NA")])
                                                    : _vm._e(),
                                                  _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticStyle: {
                                                            background:
                                                              "#f06b69",
                                                            color: "white"
                                                          },
                                                          attrs: {
                                                            "x-small": ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              _vm.customerPopup = {
                                                                user: user,
                                                                type: "pending"
                                                              }
                                                            }
                                                          }
                                                        },
                                                        [_vm._v(" Allow ")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          _c("hr", {
                                            staticStyle: { margin: "0 -1.5rem" }
                                          })
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.couponUsers && _vm.couponUsers.length > 0
                        ? _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "700"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Issued Coupons (" +
                                      _vm._s(_vm.couponUsers.length) +
                                      ")"
                                  )
                                ]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { staticStyle: { padding: "0 0.5rem" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pending-div",
                                      staticStyle: { margin: "0 -1rem" }
                                    },
                                    [
                                      _c(
                                        "ul",
                                        {
                                          staticStyle: { "padding-left": "0" }
                                        },
                                        [
                                          _vm._l(_vm.couponUsers, function(
                                            user,
                                            index
                                          ) {
                                            return _c(
                                              "li",
                                              {
                                                key: index,
                                                staticClass: "customer-record",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.customerPopup = {
                                                      user: user,
                                                      type: "issued-coupon"
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _c("strong", [
                                                    _vm._v("unused")
                                                  ])
                                                ]),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .dateFormat(
                                                          user.planStartTime
                                                        )
                                                        .substring(0, 6)
                                                    )
                                                  )
                                                ]),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.dataFormat(
                                                        1024 *
                                                          user.dataLimit *
                                                          1024
                                                      )
                                                    ) +
                                                      "/" +
                                                      _vm._s(
                                                        _vm.timeFormat(
                                                          user.timePlan
                                                        )
                                                      )
                                                  )
                                                ]),
                                                user.charges
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          "₹ " + user.charges
                                                        )
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                !user.charges
                                                  ? _c("span", [_vm._v("NA")])
                                                  : _vm._e(),
                                                _c("span")
                                              ]
                                            )
                                          }),
                                          _c("hr", {
                                            staticStyle: { margin: "0 -1.5rem" }
                                          })
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.doneRegisteredUser &&
                      _vm.doneRegisteredUser.length > 0
                        ? _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "700"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Done (" +
                                      _vm._s(_vm.doneRegisteredUser.length) +
                                      ")"
                                  )
                                ]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { staticStyle: { padding: "0 0.5rem" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "done-div",
                                      staticStyle: { margin: "0 -1rem" }
                                    },
                                    [
                                      _c(
                                        "ul",
                                        {
                                          staticStyle: { "padding-left": "0" }
                                        },
                                        [
                                          _vm._l(
                                            _vm.doneRegisteredUser,
                                            function(user, index) {
                                              return _c(
                                                "li",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "customer-record",
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      _vm.customerPopup = {
                                                        user: user,
                                                        type: "done"
                                                      }
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(user.mobile)
                                                      )
                                                    ])
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .dateFormat(
                                                            user.planStartTime
                                                          )
                                                          .substring(0, 6)
                                                      )
                                                    )
                                                  ]),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.dataFormat(
                                                          1024 *
                                                            user.dataLimit *
                                                            1024
                                                        )
                                                      ) +
                                                        "/" +
                                                        _vm._s(
                                                          _vm.timeFormat(
                                                            user.timePlan
                                                          )
                                                        )
                                                    )
                                                  ]),
                                                  user.charges
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            "₹ " + user.charges
                                                          )
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  !user.charges
                                                    ? _c("span", [_vm._v("NA")])
                                                    : _vm._e(),
                                                  _c("span", [
                                                    user.authState &&
                                                    user.otpExpiryTime >
                                                      new Date()
                                                      ? _c("img", {
                                                          staticStyle: {
                                                            "vertical-align":
                                                              "middle"
                                                          },
                                                          attrs: {
                                                            src: require("img/icons/active.svg")
                                                          }
                                                        })
                                                      : user.authState &&
                                                        user.otpExpiryTime <
                                                          new Date()
                                                      ? _c("img", {
                                                          staticStyle: {
                                                            "vertical-align":
                                                              "middle"
                                                          },
                                                          attrs: {
                                                            src: require("img/icons/expired.svg")
                                                          }
                                                        })
                                                      : _c("img", {
                                                          staticStyle: {
                                                            "vertical-align":
                                                              "middle"
                                                          },
                                                          attrs: {
                                                            src: require("img/icons/disconnected.svg")
                                                          }
                                                        })
                                                  ])
                                                ]
                                              )
                                            }
                                          ),
                                          _c("hr", {
                                            staticStyle: { margin: "0 -1.5rem" }
                                          })
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.selectedLocation.nasid &&
          _vm.couponOnlyFlowNasids.indexOf(_vm.selectedLocation.nasid) < 0
            ? _c(
                "v-tab-item",
                [
                  _c(
                    "v-container",
                    { staticStyle: { padding: "18px" } },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "p",
                            { staticClass: "fs-14 compact-bold" },
                            [
                              _vm._v(" Language Preference "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { left: "", "max-width": "207" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                {
                                                  staticClass: "help-icon",
                                                  staticStyle: {
                                                    float: "right"
                                                  }
                                                },
                                                on
                                              ),
                                              [_vm._v("mdi-help")]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2860063804
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "Language for your Wi-Fi login pages"
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-radio-group",
                            {
                              attrs: { row: "" },
                              model: {
                                value: _vm.basicSettings.ex7,
                                callback: function($$v) {
                                  _vm.$set(_vm.basicSettings, "ex7", $$v)
                                },
                                expression: "basicSettings.ex7"
                              }
                            },
                            [
                              _c("v-radio", {
                                staticClass: "fs-12 compact",
                                attrs: {
                                  label: "English",
                                  color: "success",
                                  value: "en"
                                }
                              }),
                              _c("v-radio", {
                                staticClass: "fs-12 compact",
                                attrs: {
                                  label: "Hindi",
                                  color: "success",
                                  value: "hi"
                                }
                              }),
                              _c("v-radio", {
                                staticClass: "fs-12 compact",
                                attrs: {
                                  label: "Telugu",
                                  color: "success",
                                  value: "te"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("p", { staticClass: "fs-14 mb-3 compact-bold" }, [
                            _vm._v("WiFi Name")
                          ]),
                          _c("v-text-field", {
                            staticClass: "fs-14 pt-0 compact",
                            attrs: {
                              label: "WiFi Name",
                              "single-line": "",
                              maxlength: 24,
                              type: "text",
                              rules: [
                                function() {
                                  return (
                                    !!_vm.basicSettings.ssid ||
                                    "Guest Wi-Fi name cannot be blank"
                                  )
                                },
                                function() {
                                  return (
                                    (!!_vm.basicSettings.ssid &&
                                      _vm.basicSettings.ssid.length <= 24) ||
                                    "Guest Wi-Fi name cannot exceed 24 characters"
                                  )
                                }
                              ],
                              counter: "24"
                            },
                            model: {
                              value: _vm.basicSettings.ssid,
                              callback: function($$v) {
                                _vm.$set(_vm.basicSettings, "ssid", $$v)
                              },
                              expression: "basicSettings.ssid"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "fs-14 fw-700 mb-3 compact-bold",
                              staticStyle: {
                                "line-height": "24px",
                                "margin-bottom": "10px"
                              }
                            },
                            [_vm._v("Password Protected")]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "", "max-width": "207" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c("v-switch", {
                                          staticStyle: {
                                            float: "right",
                                            "margin-top": "0px",
                                            "margin-right": "10px"
                                          },
                                          attrs: {
                                            label: "",
                                            color: "success",
                                            value: true,
                                            "hide-details": "",
                                            dense: ""
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.showPasswordWarning()
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.basicSettings
                                                .ssidPasswordEnabled,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.basicSettings,
                                                "ssidPasswordEnabled",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "basicSettings.ssidPasswordEnabled"
                                          }
                                        }),
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              staticClass: "help-icon",
                                              staticStyle: {
                                                float: "right",
                                                position: "relative",
                                                bottom: "0px",
                                                "margin-top": "5px"
                                              }
                                            },
                                            on
                                          ),
                                          [_vm._v(" mdi-help")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2447111838
                              )
                            },
                            [
                              _c("span", [
                                _vm._v("Set a password on your WiFI SSID")
                              ])
                            ]
                          ),
                          _c("v-text-field", {
                            staticClass: "fs-14 pt-0 compact wifi-password",
                            attrs: {
                              disabled: !_vm.basicSettings.ssidPasswordEnabled,
                              label: "",
                              "single-line": "",
                              maxlength: 10,
                              rules: [
                                function() {
                                  return (
                                    (!!_vm.basicSettings.ssidPassword &&
                                      !!_vm.basicSettings
                                        .ssidPasswordEnabled) ||
                                    "Guest Wi-Fi password cannot be blank. Disable to remove password."
                                  )
                                },
                                function() {
                                  return (
                                    (!!_vm.basicSettings.ssidPassword &&
                                      _vm.basicSettings.ssidPassword.length <=
                                        10) ||
                                    "Guest Wi-Fi password cannot exceed 10 characters"
                                  )
                                }
                              ],
                              counter: "10",
                              "append-icon": _vm.showPass
                                ? "mdi-eye"
                                : "mdi-eye-off",
                              type: _vm.showPass ? "text" : "password"
                            },
                            on: {
                              "click:append": function($event) {
                                _vm.showPass = !_vm.showPass
                              }
                            },
                            model: {
                              value: _vm.basicSettings.ssidPassword,
                              callback: function($$v) {
                                _vm.$set(_vm.basicSettings, "ssidPassword", $$v)
                              },
                              expression: "basicSettings.ssidPassword"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "fs-14 fw-700 mb-3 compact-bold",
                              staticStyle: {
                                "line-height": "24px",
                                "padding-top": "-10px",
                                "margin-bottom": "10px"
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    position: "relative",
                                    top: "-5px",
                                    "margin-right": "10px"
                                  },
                                  attrs: {
                                    height: "24px",
                                    "aspect-ratio": "1",
                                    width: "24px"
                                  }
                                },
                                [_vm._v("mdi-router-wireless ")]
                              ),
                              _vm._v("Max Data usage a day ")
                            ],
                            1
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "", "max-width": "207" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              staticClass: "help-icon",
                                              staticStyle: {
                                                float: "right",
                                                position: "relative",
                                                bottom: "-10px"
                                              }
                                            },
                                            on
                                          ),
                                          [_vm._v("mdi-help ")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                829472378
                              )
                            },
                            [_c("span", [_vm._v("Max data usage a day.")])]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "grid",
                                "grid-template-columns": "60px auto",
                                "margin-top": "15px"
                              }
                            },
                            [
                              _c(
                                "v-subheader",
                                {
                                  staticClass: "pl-0",
                                  staticStyle: {
                                    position: "relative",
                                    bottom: "10px"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "green-hint",
                                      staticStyle: {
                                        "font-size": "10px",
                                        padding: "1px 2px 1px 2px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.nasDatalimitLabels[
                                            _vm.nasDataLimit
                                          ]
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c("v-slider", {
                                attrs: {
                                  id: "nasDataLimit",
                                  "tick-labels": _vm.nasDatalimitLabels,
                                  max: 12,
                                  min: 0,
                                  step: "1",
                                  "tick-size": "4",
                                  color: "success",
                                  "track-color": "#999999",
                                  dense: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "thumb-label",
                                      fn: function(props) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.nasDatalimitLabels[
                                                  props.value
                                                ]
                                              ) +
                                              " "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3137389886
                                ),
                                model: {
                                  value: _vm.nasDataLimit,
                                  callback: function($$v) {
                                    _vm.nasDataLimit = $$v
                                  },
                                  expression: "nasDataLimit"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      false
                        ? _c(
                            "div",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "fs-14 fw-700 mb-3 compact-bold",
                                  staticStyle: {
                                    "line-height": "24px",
                                    "padding-top": "-10px",
                                    "margin-bottom": "10px"
                                  }
                                },
                                [
                                  _c("v-img", {
                                    staticStyle: {
                                      display: "inline-block",
                                      position: "relative",
                                      bottom: "-5px",
                                      "margin-right": "10px"
                                    },
                                    attrs: {
                                      height: "24px",
                                      "aspect-ratio": "1",
                                      width: "24px",
                                      src: require("img/icons/data.svg")
                                    }
                                  }),
                                  _vm._v(
                                    "Maximum Data a user can use in a day "
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { left: "", "max-width": "207" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                {
                                                  staticClass: "help-icon",
                                                  staticStyle: {
                                                    float: "right",
                                                    position: "relative",
                                                    bottom: "-10px"
                                                  }
                                                },
                                                on
                                              ),
                                              [_vm._v("mdi-help ")]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    829472378
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "Maximum data a user can use in a day."
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "grid",
                                    "grid-template-columns": "60px auto",
                                    "margin-top": "15px"
                                  }
                                },
                                [
                                  _c(
                                    "v-subheader",
                                    {
                                      staticClass: "pl-0",
                                      staticStyle: {
                                        position: "relative",
                                        bottom: "10px"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "green-hint",
                                          staticStyle: {
                                            "font-size": "10px",
                                            padding: "1px 2px 1px 2px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.datalimitLabels[_vm.dataLimit]
                                            )
                                          )
                                        ]
                                      ),
                                      _vm.basicSettings.unlimited
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "green-hint",
                                              staticStyle: {
                                                "font-size": "10px",
                                                padding: "1px 2px 1px 2px"
                                              }
                                            },
                                            [_vm._v(" Unlimited ")]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _c("v-slider", {
                                    attrs: {
                                      id: "dataLimit",
                                      "tick-labels": _vm.datalimitLabels,
                                      max: 12,
                                      min: 0,
                                      step: "1",
                                      "tick-size": "4",
                                      color: "success",
                                      "track-color": "#999999",
                                      dense: ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "thumb-label",
                                          fn: function(props) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.datalimitLabels[
                                                      props.value
                                                    ]
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3639130946
                                    ),
                                    model: {
                                      value: _vm.dataLimit,
                                      callback: function($$v) {
                                        _vm.dataLimit = $$v
                                      },
                                      expression: "dataLimit"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      false
                        ? _c(
                            "div",
                            { staticStyle: { "padding-top": "6px" } },
                            [
                              _c("v-icon", [_vm._v("mdi-access_alarm")]),
                              _c(
                                "span",
                                { staticClass: "fs-14 fw-700 compact-bold" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticStyle: { "padding-right": "10px" }
                                    },
                                    [_vm._v("mdi-timer-outline")]
                                  ),
                                  _vm._v("Maximum time for a session "),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { left: "", "max-width": "207" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    {
                                                      staticClass: "help-icon",
                                                      staticStyle: {
                                                        float: "right",
                                                        position: "relative",
                                                        "margin-top": "3px"
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [_vm._v("mdi-help ")]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        3685492274
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Maximum time for which a user can connect to your Wi-Fi"
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "grid",
                                    "grid-template-columns": "60px auto",
                                    "padding-top": "15px"
                                  }
                                },
                                [
                                  _c(
                                    "v-subheader",
                                    {
                                      staticClass: "pl-0",
                                      staticStyle: {
                                        position: "relative",
                                        bottom: "10px"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "green-hint",
                                          staticStyle: {
                                            "font-size": "10px",
                                            padding: "1px 2px 1px 2px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.sessionLabels[
                                                _vm.sessionTimeOut
                                              ]
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c("v-slider", {
                                    attrs: {
                                      id: "timeout",
                                      "tick-labels": _vm.sessionLabels,
                                      max: 13,
                                      min: 0,
                                      step: "1",
                                      "tick-size": "4",
                                      color: "success",
                                      "track-color": "#999999",
                                      dense: ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "thumb-label",
                                          fn: function(props) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.sessionLabels[
                                                      props.value
                                                    ]
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1537606457
                                    ),
                                    model: {
                                      value: _vm.sessionTimeOut,
                                      callback: function($$v) {
                                        _vm.sessionTimeOut = $$v
                                      },
                                      expression: "sessionTimeOut"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      false
                        ? _c(
                            "div",
                            { staticStyle: { "margin-top": "-10px" } },
                            [
                              _c("v-icon", [
                                _vm._v("mdi-stay_primary_portrait")
                              ]),
                              _c(
                                "p",
                                { staticClass: "fs-14 fw-700 compact-bold" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticStyle: { "padding-right": "10px" }
                                    },
                                    [_vm._v("mdi-cellphone")]
                                  ),
                                  _vm._v("No. of Devices / User "),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { left: "", "max-width": "207" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    {
                                                      staticClass: "help-icon",
                                                      staticStyle: {
                                                        float: "right"
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [_vm._v("mdi-help")]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2860063804
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " Maximum number of devices one user can connect to your Wi-Fi "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "grid",
                                    "grid-template-columns": "58px auto"
                                  }
                                },
                                [
                                  _c(
                                    "v-subheader",
                                    {
                                      staticClass: "pl-0",
                                      staticStyle: {
                                        position: "relative",
                                        bottom: "10px"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "green-hint",
                                          staticStyle: {
                                            "font-size": "10px",
                                            padding: "1px 2px 1px 2px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.basicSettings.devicesPerUser
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c("v-slider", {
                                    attrs: {
                                      color: "success",
                                      "track-color": "#999999",
                                      min: "1",
                                      max: "100",
                                      "thumb-label": ""
                                    },
                                    model: {
                                      value: _vm.basicSettings.devicesPerUser,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.basicSettings,
                                          "devicesPerUser",
                                          $$v
                                        )
                                      },
                                      expression: "basicSettings.devicesPerUser"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-sheet",
                        {
                          staticStyle: { "margin-top": "25px" },
                          on: {
                            click: function($event) {
                              return _vm.planNPayMethod({ page: "plans" })
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "py-4 pl-2 pr-0" },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "18px"
                                  }
                                },
                                [_vm._v("Manage Data Plans")]
                              ),
                              _c(
                                "v-icon",
                                {
                                  staticStyle: {
                                    color: "blue",
                                    float: "right",
                                    position: "relative",
                                    "margin-right": "-5px"
                                  }
                                },
                                [_vm._v("mdi-chevron-right")]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "v-sheet",
                        {
                          on: {
                            click: function($event) {
                              return _vm.planNPayMethod({
                                page: "payment",
                                editUpi: true
                              })
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "py-4 pl-2 pr-0" },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "18px"
                                  }
                                },
                                [_vm._v("Manage Payment Modes")]
                              ),
                              _c(
                                "v-icon",
                                {
                                  staticStyle: {
                                    color: "blue",
                                    float: "right",
                                    position: "relative",
                                    "margin-right": "-5px"
                                  }
                                },
                                [_vm._v("mdi-chevron-right")]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "v-sheet",
                        {
                          staticStyle: { "margin-top": "25px" },
                          on: {
                            click: function($event) {
                              _vm.showAdvancedSettings = true
                              _vm.GetAdvancedSettings()
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "py-4 pl-2 pr-0" },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "18px"
                                  }
                                },
                                [_vm._v("Advanced Settings")]
                              ),
                              _c(
                                "v-icon",
                                {
                                  staticStyle: {
                                    color: "blue",
                                    float: "right",
                                    position: "relative",
                                    "margin-right": "-5px"
                                  }
                                },
                                [_vm._v("mdi-chevron-right")]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "", "max-width": "207" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              staticClass: "help-icon",
                                              staticStyle: {
                                                float: "right",
                                                position: "relative",
                                                "margin-top": "8px"
                                              }
                                            },
                                            on
                                          ),
                                          [_vm._v("mdi-help ")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                425263225
                              )
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Guests will be able to automatically log in for 30 days."
                                )
                              ])
                            ]
                          ),
                          _c("v-switch", {
                            staticStyle: {
                              float: "right",
                              "margin-top": "0px",
                              "margin-right": "30px"
                            },
                            attrs: {
                              label: "Auto Login",
                              color: "success",
                              value: "yes",
                              "hide-details": "",
                              dense: ""
                            },
                            model: {
                              value: _vm.basicSettings.autoLogin,
                              callback: function($$v) {
                                _vm.$set(_vm.basicSettings, "autoLogin", $$v)
                              },
                              expression: "basicSettings.autoLogin"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "pb-12",
                          staticStyle: { "margin-bottom": "60px" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled:
                                  !_vm.basicSettings.ssidPassword &&
                                  _vm.basicSettings.ssidPasswordEnabled,
                                id: "submit",
                                width: "100%",
                                height: "48"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.saveConfig()
                                }
                              }
                            },
                            [_vm._v("Save")]
                          )
                        ],
                        1
                      ),
                      _vm.nonPremium()
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                border: "solid 1px red",
                                "margin-left": "-5px",
                                width: "100%",
                                "background-color": "rgba(255,255,255,0.9)",
                                display: "block",
                                height: "470px",
                                position: "absolute",
                                top: "260px",
                                "text-align": "center"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "block",
                                    position: "relative",
                                    top: "100px"
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: { src: require("img/locked.svg") }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "block",
                                        "font-weight": "bold",
                                        "font-size": "22px"
                                      }
                                    },
                                    [_vm._v("Premium Feature")]
                                  ),
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "upgrade-banner",
                                      attrs: {
                                        height: "55px",
                                        width: "100%",
                                        color: "#f3f3f3"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "upgrade-banner-text-col"
                                            },
                                            [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "upgrade-banner-text"
                                                },
                                                [
                                                  _c("li", [
                                                    _vm._v(
                                                      "- Track your customers"
                                                    )
                                                  ]),
                                                  _c("li", [
                                                    _vm._v(
                                                      "- Grow you business"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "upgrade-banner-cta-col"
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "upgrade-banner-cta",
                                                  staticStyle: {
                                                    color: "white"
                                                  },
                                                  attrs: { color: "#214294" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.GoToPaymentPage()
                                                    }
                                                  }
                                                },
                                                [_vm._v("PAY TO UPGRADE")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.showPlans,
            callback: function($$v) {
              _vm.showPlans = $$v
            },
            expression: "showPlans"
          }
        },
        [
          _c("Plans", {
            attrs: { location: _vm.selectedLocation, view: _vm.view },
            on: {
              close: function($event) {
                _vm.showPlans = false
              }
            }
          })
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "600px" },
          model: {
            value: _vm.showPasswordPopup,
            callback: function($$v) {
              _vm.showPasswordPopup = $$v
            },
            expression: "showPasswordPopup"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c(
                  "span",
                  {
                    staticClass: "headline",
                    staticStyle: {
                      "font-weight": "bold",
                      "font-size": "18px !important"
                    }
                  },
                  [_vm._v("Not Recommended")]
                )
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6", md: "4" } },
                            [
                              _vm._v(
                                "If you enable this, your customers will sign in using phone number and password both."
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "gray grey", text: "" },
                      on: {
                        click: function($event) {
                          _vm.showPasswordPopup = false
                          _vm.basicSettings.ssidPasswordEnabled = false
                        }
                      }
                    },
                    [_vm._v(" Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary",
                      attrs: {
                        id: "submit",
                        color: "white darken-1",
                        text: ""
                      },
                      on: {
                        click: function($event) {
                          _vm.showPasswordPopup = false
                          _vm.basicSettings.ssidPasswordEnabled = true
                        }
                      }
                    },
                    [_vm._v("Confirm")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "600px" },
          model: {
            value: _vm.showDataSettingWarning,
            callback: function($$v) {
              _vm.showDataSettingWarning = $$v
            },
            expression: "showDataSettingWarning"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c(
                  "span",
                  {
                    staticClass: "headline",
                    staticStyle: {
                      "font-weight": "bold",
                      "font-size": "18px !important"
                    }
                  },
                  [_vm._v("Error")]
                )
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticStyle: { color: "grey" },
                              attrs: { cols: "12", sm: "6", md: "4" }
                            },
                            [
                              _vm._v(
                                'Setting for "Max Data usage a Day" cannot be less than setting for "Maximum Data a user can use in a day".'
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary",
                      attrs: {
                        id: "submit",
                        color: "white darken-1",
                        text: ""
                      },
                      on: {
                        click: function($event) {
                          _vm.showDataSettingWarning = false
                        }
                      }
                    },
                    [_vm._v("Close ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }